import { SETTINGS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { ISettings } from "../../shared/interfaces/settings/ISettings";

export const SettingsService = {
  get: () => requests.get(`${SETTINGS_URL}`),
  update: (params: ISettings) => requests.post(`${SETTINGS_URL}`, params),
};
